import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AutoStoringFileSelector from "@/lib/components/form/file/auto-storing/AutoStoringFileSelector.vue";
import {PropType} from "vue";
import {AbstractStoreManagerBuilder} from "@/lib/store/manager/abstract/AbstractStoreManager";
import {ImagesStoreManager} from "@/lib/store/manager/media/ImagesStoreManager";


export default /*#__PURE__*/_defineComponent({
  name: 'ImageSelector',
  props: {
  text: {
    type: String,
    required: true,
  },
  is_multiple: Boolean,
  // Your store manager
  manager_class: {
    type: Object as PropType<typeof AbstractStoreManagerBuilder>,
    default: ImagesStoreManager
  },
  // The method from your store manager to add a Csv
  manager_mutator: {
    type: String,
    default: "addMedia"
  },
  linkToImageInstanceId: String,
},
  emits: ["onImagesStored"],
  setup(__props) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AutoStoringFileSelector, {
    icon: __props.is_multiple ? require('@/lib/assets/img/icons/images.svg') : require('@/lib/assets/img/icons/image.svg'),
    text: __props.text,
    is_multiple: __props.is_multiple,
    manager_class: __props.manager_class,
    "link-to-instance-id": __props.linkToImageInstanceId,
    manager_mutator: __props.manager_mutator,
    accept: "image/*",
    onOnStored: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onImagesStored')))
  }, null, 8, ["icon", "text", "is_multiple", "manager_class", "link-to-instance-id", "manager_mutator"]))
}
}

})